import React from "react";
import PartnerBanner from "./Partnerbanner";
import { useTranslation } from "react-i18next";
import PartnershipOpportunities from "./PartnershipOpportunities";
import WhyPartnerWithSmiklearn from "./PartnerWithSmiklearn";
import TrustedBrandsPage from "./TrustedBrands";
import FAQAccordion from "./Faq";
const Partners = () => {
  return (
    <div className="partners">
      <PartnerBanner />
      <PartnershipOpportunities />
      <WhyPartnerWithSmiklearn />
      <TrustedBrandsPage />
      <FAQAccordion />
    </div>
  );
};
export default Partners;
